async function refreshGlobalBag() {
  await customElements.whenDefined('ac-cart-overlay');
  const bag = document.querySelector('ac-cart-overlay');
  const cart = await bag?.refresh?.();
  document.dispatchEvent(new CustomEvent('ac:cart-updated', { detail: { cart, refreshed: Boolean(cart) } }));
  return cart;
}

function openGlobalBag(defaultHandler) {
  const trigger = document.querySelector('[data-ac-ref-open="cart"]');
  if (!trigger) return defaultHandler();
  trigger.click();
  return undefined;
}

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;
  actions.openCart.configure({
    handler(defaultHandler) {
      return openGlobalBag(defaultHandler);
    }
  });
  actions.updateCart.configure({
    eventTarget: () => document,
    async handler(defaultHandler) {
      const result = await defaultHandler();
      await refreshGlobalBag();
      return result;
    }
  });
}

if (window.Shopify?.actions) initStandardActions();
else document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
